import { useContext } from "react";
import ProductGuidanceContext from "./ProductGuidanceContext";

export default function useProductGuidance() {
  const context = useContext(ProductGuidanceContext);

  if (!context) {
    throw new Error(
      "useProductGuidance must be used within ProductGuidanceProvider"
    );
  }

  return context;
}
